module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAQCAYAAAAvf+5AAAAA/UlEQVQoU8WRMUvDYBCGn/uiBgdX4Vv8F7q1FloQnMRNBxcTgqOjS/mgi5Nr8oGLOCmC4CC4NX9BEH+DII5SFT1Ja2saSVdvu3ufO+69EyrxSmMtIFgJ6V+VJSknH7Q6CjcKi8BRSP94rE/AAc1NQa5BFn6btRuS94p8CL7R2gK9BJmvrgLaC8m7MqCxIZhbEPMXGlWEr315Z31VoVMHFfVPNJ8yMwv+TzBN02UR2RGpd62qd+K9PwROZhkBnDjn5qy1F8B2DfwItIeunXPGWnsO7FbgB2NMO47jp6nzZFl2JiJ7P/B9MSlJkufJr8tTvPcHwFIQBKdRFL2MtW/eozs5sq+FiAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/imgs/mall/asc.png
// module id = tWUH
// module chunks = 1